import { setCurrentUser } from '@entities/current-user/model/slice';
import { useLogoutMutation } from '@features/current-user/logout/api/logout-api';
import { removeCredentials } from '@shared/lib/utils/credentials/credentials';
import { useDispatch } from 'react-redux';

export const useLogout = () => {
    const dispatch = useDispatch();
    const [logoutUser] = useLogoutMutation();

    const handleLogout = () => {
        logoutUser();
        removeCredentials();
        dispatch(setCurrentUser(null));
    };

    return { logout: handleLogout };
};
